export interface InternetConnection {
  id: string;
  org_id: string;
  site_id?: string | null;
  zone_id?: string | null;
  system_id?: string | null;
  label: string;
  connection_type?: string | null;
  supplier?: string | null;
  description?: string | null;
  external_link?: string | null;
  position_x?: number | null;
  position_y?: number | null;
  parent_node_id?: string | null;
  owner_id?: string | null;
  created_at: string;
  updated_at: string;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface InternetConnectionInsert {
  label: string;
  site_id?: string | null;
  zone_id?: string | null;
  system_id?: string | null;
  connection_type?: string | null;
  supplier?: string | null;
  description?: string | null;
  external_link?: string | null;
  position_x?: number | null;
  position_y?: number | null;
  parent_node_id?: string | null;
  owner_id?: string | null;
}

export interface InternetConnectionUpdate extends Partial<InternetConnectionInsert> {}

export type InternetParentType = 'site' | 'zone' | 'system';

export const CONNECTION_TYPES = [
  'Fiber',
  'DSL',
  'Cable',
  '4G/5G',
  'Satellite',
  'Leased Line',
  'MPLS',
  'Other'
] as const;

export type ConnectionType = typeof CONNECTION_TYPES[number];
